<template>
  <div>
    <div class="app-advert-box">
      <a class="app-advert bottom-fixed" href="#">
        <img :src="logoImage" class="logo" />
        <div class="text-group">
          <p class="text">前往{{ name }}APP</p>
          <p class="text">{{ text }}</p>
        </div>
        <OpenApp :unitKey="schemaUnitKey" :options="config" :appendParam="null">
          <p class="btn">{{ buttonText ? buttonText : '打开' }}</p>
        </OpenApp>
      </a>
    </div>
  </div>
</template>

<script>
import OpenApp from './OpenApp.vue'
export default {
  props: ['logoImage', 'name', 'text', 'schemaUnitKey', 'buttonText', 'replace_id'],
  components: { OpenApp },
  data() {
    return { config: null }
  },
  methods: {
    // 唤醒APP
    openAPPSchema(schema) {
      let protocal = this.$brandConfig.getCurrentBrandSchemaParam.protocal
      let failUrl = this.$brandConfig.getCurrentBrandSchemaParam.failUrl

      this.$openSchema({
        protocal: protocal,
        schema: 'openUnit/schema?params=' + JSON.stringify(schema),
        failUrl: `https://a.app.qq.com/o/simple.jsp?pkgname=${failUrl}`,
      })
    },
    // 执行打开app方法
    openApp() {
      // 修改url链接 购买状态
      this.replaceURLBuyState()

      let unitKey = this.schemaUnitKey,
        brand = this.$brandConfig.getCurrentBrandSchemaParam.protocal,
        province = this.$route.query.province,
        appkey = brand + '.' + province
      const param = { brand, province }
      if (brand && province) {
        param.appkey = appkey
      }
      if (this.$route.query.no) {
        param.no = this.$route.query.no
      }
      if (unitKey === 'Advanced') {
        param.project_no = this.$route.query.no
      }

      if (unitKey === 'CourseCollection') {
        param.collection_no = this.$route.query.collection_no
      }

      const id = this.replace_id || this.$route.query.id
      if (id) {
        param.id = id.toString()
      }
      const config = {
        type: 'openUnit',
        option: {
          unitKey,
          param,
        },
      }

      // 安卓系列课兼容
      if (unitKey === 'CourseSeries') {
        config.param = { unitKey: 'Home' }
      }
      this.openAPPSchema(config)
    },

    // 修改url链接 购买状态(用户微信购买 浏览器打开当前页面)
    replaceURLBuyState() {
      if (!this.$browser.isWXBrowser()) return
      let fullPath = window.location.pathname + window.location.search
      if (fullPath.indexOf('buyState') < 0) {
        let url = fullPath + '&buyState'
        history.replaceState({}, '', url)
      }
    },

    updateConfig(id) {
      let brand = this.$brandConfig.getCurrentBrandSchemaParam.protocal,
        province = this.$route.query.province,
        appkey = brand + '.' + province
      const param = { brand, province }
      if (brand && province) {
        param.appkey = appkey
      }
      if (this.$route.query.no) {
        param.no = this.$route.query.no
      }
      if (id) {
        param.id = id.toString()
      }
      this.config = param
    },
  },
}
</script>

<style lang="scss" scoped>
// app广告
.app-advert {
  @include flex_between_center;
  @include maxWidth();
  $height: 1.71rem;
  padding: 0.43rem 0.38rem;
  height: $height;
  box-sizing: border-box;
  background-color: #fff;

  b &-box {
    height: $height;
  }

  &.bottom-fixed {
    z-index: 100;
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    max-width: 750px;
    transform: translateX(-50%);
    box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.05);
  }

  .logo {
    margin-right: 0.2rem;
    width: 0.96rem;
    height: 0.96rem;
  }

  .text {
    &-group {
      flex: 1;
    }

    font-size: $font28;
    color: #3c3d42;
    line-height: 0.54rem;

    &:nth-child(1) {
      font-weight: bold;
    }
  }

  .btn {
    @include flex_center;
    width: 2.03rem;
    height: 0.7rem;
    border-radius: 1rem;
    background-color: var(--main-color);
    color: #fff;
    font-size: $font26;
  }
}
</style>
